import React from 'react';
import styles from '../../styles/SkeletonLoader.module.css';

interface SkeletonLoaderProps {
  count?: number;
  variant?: 'card' | 'table' | 'list' | 'custom';
  className?: string;
  height?: string;
  width?: string;
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
  count = 4,
  variant = 'card',
  className = '',
  height,
  width
}) => {
  const renderSkeletonItem = (index: number) => {
    switch (variant) {
      case 'card':
        return (
          <div key={index} className={`${styles.skeletonCard} ${className}`}>
            <div className={styles.skeletonContent}>
              <div className={styles.skeletonTextGroup}>
                <div className={`${styles.skeletonLine} ${styles.skeletonLineLong}`}></div>
                <div className={`${styles.skeletonLine} ${styles.skeletonLineMedium}`}></div>
                <div className={`${styles.skeletonLine} ${styles.skeletonLineShort}`}></div>
              </div>
              <div className={styles.skeletonImage}></div>
            </div>
          </div>
        );
      
      case 'table':
        return (
          <div key={index} className={`${styles.skeletonTableRow} ${className}`}>
            <div className={styles.skeletonTableCell}>
              <div className={styles.skeletonCheckbox}></div>
            </div>
            <div className={styles.skeletonTableCell}>
              <div className={styles.skeletonAvatar}></div>
              <div className={styles.skeletonTextGroup}>
                <div className={`${styles.skeletonLine} ${styles.skeletonLineMedium}`}></div>
                <div className={`${styles.skeletonLine} ${styles.skeletonLineShort}`}></div>
              </div>
            </div>
            <div className={styles.skeletonTableCell}>
              <div className={`${styles.skeletonLine} ${styles.skeletonLineShort}`}></div>
            </div>
            <div className={styles.skeletonTableCell}>
              <div className={styles.skeletonBadge}></div>
            </div>
            <div className={styles.skeletonTableCell}>
              <div className={styles.skeletonBadge}></div>
            </div>
            <div className={styles.skeletonTableCell}>
              <div className={`${styles.skeletonLine} ${styles.skeletonLineShort}`}></div>
            </div>
            <div className={styles.skeletonTableCell}>
              <div className={`${styles.skeletonLine} ${styles.skeletonLineShort}`}></div>
            </div>
            <div className={styles.skeletonTableCell}>
              <div className={styles.skeletonActions}>
                <div className={styles.skeletonButton}></div>
                <div className={styles.skeletonButton}></div>
                <div className={styles.skeletonButton}></div>
              </div>
            </div>
          </div>
        );
      
      case 'list':
        return (
          <div key={index} className={`${styles.skeletonListItem} ${className}`}>
            <div className={styles.skeletonContent}>
              <div className={styles.skeletonTextGroup}>
                <div className={`${styles.skeletonLine} ${styles.skeletonLineLong}`}></div>
                <div className={`${styles.skeletonLine} ${styles.skeletonLineMedium}`}></div>
              </div>
              <div className={styles.skeletonImage}></div>
            </div>
          </div>
        );
      
      case 'custom':
        return (
          <div 
            key={index} 
            className={`${styles.skeletonCustom} ${className}`}
            style={{ height, width }}
          >
            <div className={styles.skeletonShimmer}></div>
          </div>
        );
      
      default:
        return null;
    }
  };

  return (
    <div className={styles.skeletonContainer}>
      {Array.from({ length: count }, (_, index) => renderSkeletonItem(index))}
    </div>
  );
};

export default SkeletonLoader;
